interface Props {
  onClick?: () => void;
}

const Overlay: React.FC<Props> = ({ onClick }) => {
  return <div className="fixed inset-0 z-40 bg-[#7f7f7f]/30" onClick={onClick} />;
};

export default Overlay;
